import Tool, { type ToolArgs } from '../../tools/Tool';
import History from '../History';

class ToolRedo extends Tool {
  static toolName = 'Redo';
  static iconClass = 'fa-solid fa-rotate-right';
  static shortcut = 'Cmd+Shift+z,Cmd+Y';

  static action({ editor, element }: ToolArgs): void {
    History.redo(editor);
  }

  static isEnabled({ editor, element }: ToolArgs): boolean {
    return History.getForEditor(editor)?.canRedo;
  }
}

export default ToolRedo;
